"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _formatBp = require("./formatBp");
Object.keys(_formatBp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formatBp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatBp[key];
    }
  });
});
var _formatCurrency = require("./formatCurrency");
Object.keys(_formatCurrency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formatCurrency[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatCurrency[key];
    }
  });
});
var _formatDate = require("./formatDate");
Object.keys(_formatDate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formatDate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatDate[key];
    }
  });
});
var _formatNumber = require("./formatNumber");
Object.keys(_formatNumber).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formatNumber[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatNumber[key];
    }
  });
});
var _formatPercent = require("./formatPercent");
Object.keys(_formatPercent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formatPercent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatPercent[key];
    }
  });
});
var _formatPoints = require("./formatPoints");
Object.keys(_formatPoints).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formatPoints[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatPoints[key];
    }
  });
});
//# sourceMappingURL=index.js.map